import { Component, Input } from '@angular/core';
import { RTO_STARTDATE_ENDDATE_WARNING_MESSAGE } from '../../services/realtime-constants';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'nova-rto-alert-icon',
    templateUrl: './rto-alert-icon.html',
    styleUrls: ['./rto-alert-icon.scss'],
    standalone: true,
    imports: [CommonModule, MatIconModule, MatTooltipModule]
})
export class RtoAlertIconComponent {
    @Input() enabled: boolean;
    @Input() toolTipText: string | null = RTO_STARTDATE_ENDDATE_WARNING_MESSAGE;

    // Getter to return the default tooltip text if toolTipText is null or undefined
    get displayToolTipText(): string {
        return this.toolTipText ?? RTO_STARTDATE_ENDDATE_WARNING_MESSAGE;
    }
}
